import { Link } from "react-router-dom";
import { Youtube, Instagram } from "lucide-react";
import chefXMascot from "@/assets/chef-x-mascot.png";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-muted/30">
      <div className="container py-8 md:py-12">
        <div className="grid gap-8 md:grid-cols-4">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-full overflow-hidden">
                <img src={chefXMascot} alt="Chef X" className="h-8 w-8 object-cover" />
              </div>
              <span className="font-display text-lg font-semibold">
                Kitchen Assistant X
              </span>
            </div>
            <p className="text-sm text-muted-foreground">
              Your AI-powered kitchen companion. Smarter meals using what you already have.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-display text-sm font-semibold">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/chat" className="text-muted-foreground hover:text-primary transition-colors">
                  Start Cooking
                </Link>
              </li>
              <li>
                <Link to="/my-recipes" className="text-muted-foreground hover:text-primary transition-colors">
                  My Recipes
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-muted-foreground hover:text-primary transition-colors">
                  How It Works
                </Link>
              </li>
            </ul>
          </div>

          {/* Information */}
          <div className="space-y-4">
            <h4 className="font-display text-sm font-semibold">Information</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/food-safety" className="text-muted-foreground hover:text-primary transition-colors">
                  Food Safety
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div className="space-y-4">
            <h4 className="font-display text-sm font-semibold">Follow Us</h4>
            <div className="flex gap-3">
              <a 
                href="https://youtube.com/@kitchenassistantx" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-colors"
                aria-label="YouTube"
              >
                <Youtube className="h-5 w-5" />
              </a>
              <a 
                href="https://instagram.com/kitchenassistantx" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-muted text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t pt-8 text-center text-sm text-muted-foreground">
          <p>© {currentYear} Kitchen Assistant X. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
